import { createSelector } from '@ngrx/store';
import * as authState from '../auth.reducer';
import * as validateTokenReducer from '../reducers/validate-token.reducer';

export const selectValidateTokenState = createSelector(
  authState.getValidateTokenState,
  state => state
);

export const selectValidateTokenResponse = createSelector(
  selectValidateTokenState,
  validateTokenReducer.getValidateTokenResponse
);

export const selectValidateTokenRoles = createSelector(
  selectValidateTokenResponse,
  response => response?.roles || []
);

export const selectValidateTokenPermissions = createSelector(
  selectValidateTokenResponse,
  response => response?.permissions || []
);

export const selectValidateTokenLegalEntityPermissions = createSelector(
  selectValidateTokenResponse,
  response => response?.legalEntityPermissions || []
);

export const selectValidateTokenCurrentLegalEntityId = createSelector(
  selectValidateTokenResponse,
  response => response?.currentLegalEntityId || undefined
);
